'use client'

import React, { ReactElement } from 'react'

export interface SelectListboxProps {
    id: string
    ariaLabelledby?: string
    multiselectable?: boolean
    children: React.ReactNode
}

/**
 * Listbox container for combobox options. Used by both single and multi-select comboboxes.
 */
export const SelectListbox = ({
    id,
    ariaLabelledby,
    multiselectable = false,
    children,
}: SelectListboxProps): ReactElement => (
    <ul
        id={id}
        role="listbox"
        aria-multiselectable={multiselectable || undefined}
        aria-labelledby={ariaLabelledby}
        className="absolute z-50 mt-1 w-full max-h-60 overflow-auto bg-white border border-shade-200 shadow-lg"
    >
        {children}
    </ul>
)
